// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"63625764","453":"283047ad","905":"407c01d0"}[chunkId] + ".chunk.js";
};